<template>
  <!-- Optional visible label -->
  <p
    v-if="$slots.label"
    class="db-details-icon-label"
  >
    <slot name="label" />
  </p>

  <!-- Icon with tooltip (usually when there is no label above) -->
  <DbTooltip v-if="$slots.tooltiplabel">
    <!-- Icon slot -->
    <div class="db-details-icon-icon">
      <slot name="icon" />
    </div>
    <!-- Accessible text alternative for our tooltip -->
    <span class="db-visually-hidden">
      <slot name="tooltiplabel" />
    </span>
    <!-- Tooltip content -->
    <template v-slot:content>
      <span class="db-bold"><slot name="tooltiplabel" /></span>
    </template>
  </DbTooltip>

  <!-- No tooltip, icon as it is -->
  <div
    v-else
    class="db-details-icons-item-icon"
  >
    <slot name="icon" />
  </div>

  <!-- Value to put next to the icon  -->
  <div class="db-list-details-icons-item-value"><slot name="value" /></div>
  <div class="db-list-details-icons-item-label">
    <slot
      v-if="$slots.tooltiplabel"
      name="tooltiplabel"
    />
    <slot
      v-if="$slots.type"
      name="type"
    />
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.db-app .db-list-details-icons .db-list-details-icons-item .db-list-details-icons-item-value {
  align-self: center;
  display: inline;
}

.db-app .db-details-icons-item-icon {
  grid-row: 1 / 2 span !important;
  width: 28px;
  height: 28px;
  place-items: center;
  display: grid;
}

.db-app
  .db-list-details-icons.db-list-details-icons-rows
  .db-list-details-icons-item
  .db-list-details-icons-item-value,
.db-app
  .db-list-details-icons.db-modal-infos
  .db-list-details-icons-item
  .db-list-details-icons-item-value {
  grid-column: 2;
  font-family: var(--db_body_text_font_family);
  font-size: var(--db_small_body_text_font_size);
  color: var(--db_iconography_color);
  font-weight: 600;
  margin-bottom: auto;
  height: 100%;
  line-height: normal;
  white-space: nowrap;
}
.db-app
  .db-list-details-icons.db-list-details-icons-rows
  .db-list-details-icons-item
  .db-list-details-icons-item-value:before,
.db-app
  .db-list-details-icons.db-modal-infos
  .db-list-details-icons-item
  .db-list-details-icons-item-value:before {
  content: '';
}
.db-app
  .db-modal-details-content-venue
  .db-list-details-icons.db-modal-infos
  .db-list-details-icons-item
  .db-list-details-icons-item-value:before {
  content: '';
}

.db-app .db-list-details-icons .db-list-details-icons-item .db-list-details-icons-item-label {
  display: none;
}

.db-app
  .db-list-details-icons.db-list-details-icons-rows
  .db-list-details-icons-item
  .db-list-details-icons-item-label {
  display: grid;
  grid-column: 2;
  grid-row: 1;
  color: var(--db_iconography_color);
  font-family: var(--db_body_text_font_family);
  font-size: var(--db-font-size-10);
  font-weight: 500;
  margin-top: auto;
  align-self: start;
}
</style>
